export default {
  PriceUnit: 'HK$',
	IndexNavbar: {
		HomePage: "首页",
		Founder: "创始人",
		Artwork: "艺术品",
		Pieces: "件",
		Artists: "艺术家",
		PrivateArtSteward: "私人艺术管家",
		BusinessModelCase: "商业模式",
		Photo: "活动相册",
		LatestNews: "最新消息",
		AboutUs: "关于我们",
		RecommendArtwork: "推荐艺术品",
		RecommendArtists: "艺术家",
		JumpLink: "相关视频",
		NewsDetail: '消息详情'
	},
	IndexAboutUs: {
		AboutUs: "关于我们",
		Introduce: "经艺联倾力打造的当代原创艺术品电商交易服务平台。旨在推动艺术品消费大众化，依托于专业团队，在全国范围内持续挖掘优秀艺术品，将大量经过严格筛选的高质量原创艺术品通过线上艺术品电商平台带给大众，形成一整套专业、可信赖的艺术消费服务",
		Address: "地址: 香港铜锣湾希慎道8号裕景商业中心2楼97室",
		Tel: "电邮: info@kingsarts.com"
	},
	FooterNavbar: {
		Artwork: "艺术品",
		Artists: "艺术家",
		PromoteSales: "推广销售",
		PromoteManager: "推广经理",
		SecondSale: "二次销售",
		SalesCase: "销售案例",
		SiteName: "经艺联",
		AboutUs: "关于我们"
	},
	Founder: {
		SendWord: "黄博士寄语",
		SendWordMsg1: "活在艺术多姿多彩 相反 枯燥无味",
		SendWordMsg2: "活在艺术吃尽八方 相反 力竭声嘶",
		Founder: "黄经国博士",
    TakeOffice1: "冠军专业管理有限公司",
    TakeOffice2: "Asia Trusted Life Agents & Advisors Award 2021",
    TakeOffice3: "经艺控股有限公司",
    TakeOffice4: "经艺（深圳）艺术品电子商务有限公司",
    TakeOffice5: "“喂我” 实现工程有限公司",
    TakeOffice6: "香港中文大学新亚书院",
    TakeOffice7: "香港理工大学基金",
    TakeOffice8: "清华大学美术学院-清华大学经济管理学院-苏富比艺术学院",
    TakeOffice9: "香港理工大学总裁协会",
    TakeOffice10: "中国古董艺术总会",
    TakeOffice11: "香港亚洲狮子会",
    TakeOffice12: "香港银行学会",
    TakeOffice13: "镜报",
    TakeOffice14: "2007-2015年香港学术评审局",
    TakeOffice15: "2007-2008年持续两届荣获CEO资本才俊",
    Position1: "主席",
    Position2: "终身成就奖",
    Position3: "主席",
    Position4: "主席",
    Position5: "主席",
    Position6: "校董",
    Position7: "永远荣誉副会长",
    Position8: "艺术管理硕士",
    Position9: "副理事长",
    Position10: "主席",
    Position11: "前任会长",
    Position12: "专业财富管理师",
    Position13: "顾问",
    Position14: "委任行业/学科专家",
    Position15: "非凡品牌大奖",
		Story1: "黄博士「冠军专业管理有限公司」主席，拥有超过3,500名财务策划顾问「冠军家族团队」，当中包括24位资深区域总监及区域总监。工余时间在美国不断进修，获取众多科目不同资格，为人才资本培训专家、从事企业辅导、领袖培训、营销推广、保险及财务顾问管理工作数十年，为行业的翘楚。近年也获得保险行业终身成就奖。黄博士亦是香港中文大学《新亚书院》校董、《香港理工大学基金》永远荣誉副会长、《香港理工大学总裁协会》副理事长及《世界杰出华人会》创会主席。兴趣方面也累积古董数十年收藏经验，近70岁也考取《清华大学》美术学院-《清华大学》经济管理学院-《苏富比》艺术学院-艺术管理硕士资格。",
		Story2: "與全國政協副主席梁振英先生合照",
		Story3: "荣获2015年APEA亚太企业家奖",
		Story4: "黄经国博士与香港特别行政区行政长官林郑月娥女士合照",
		Story5: "2017年《镜报》顾问第六届杰出企业社会责任奖中致词",
		Story6: "与树仁大学校监胡鸿烈大律师合照",
		Story7: "2004年接受「美国总统优质教育奖」并在典礼中致词",
		Story8: "黄博士于2019年3月毕业《清华大学》美术学院-《清华大学》经济管理学院-《苏富比》艺术学院-艺术管理硕士",
		Story9: "与澳门特首崔世安先生合照士",
		Story10: "于《镜报》第六届杰出企业社会责任奖颁奖典礼与梁振英先生担任颁奖嘉宾",
		Story11: "与前政务司司长唐英年合照",
	},
	PrivateArtSteward: {
		ArtSteward: "经艺私人艺术管家",
		Content1:"",
		Content2: "职责及工作指引：",
		Content3: "1. 代理四个商家或艺术家，充分了解每件艺术作品的创作理念及内涵价值。",
		Content4: "2. 线下协助艺术爱好者或收藏家了解所代理的艺术家的作品。",
		Content5: "3. 沟通和协调艺术爱好者在购买过程中的各种疑问。",
		Content6: "4. 进行细致严谨的交收跟进。",
		Content7: "5. 与各艺术大咖深入交流的机会。",
		Content8: "6. 个人的社交圈将得到更深入的扩展。",
		Content9: "7. 持续进修艺术培训及市场策略导师的指导，个人创造力最大程度彰显。",
		Content10: "8. 世界各地游学及艺术深造的机会。",
		Content11: "",
		Content12: "",
		Content13: "",
		Content14: "",
	},
	BusinessModel: {
		Amateur: "艺术藏家",
		AmateurUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business1.png",
		Artists: "艺术家",
		ArtistsUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business2.png",
		ArtSpecialist: "艺术总监",
		ArtSpecialistUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business3.png",
		PrivateArtSteward: "私人艺术行政管家",
		PrivateArtStewardUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business4.png",
		ArtPromotionManager: "私人艺术管家",
		ArtPromotionManagerUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business5.png",
		ModelCase: "商业模式案例"
	},
	AboutUs: {
		Clauses: "经艺联使命",
		Clauses1: "为艺术家和藏家架起沟通的桥梁",
		Clauses2: "发掘和推广中国当代艺术",
		Clauses3: "让艺术融入每个人的日常生活",
		Clauses4: "",
		SharedValues: "经艺联价值观",
		Challenge : "",
		Activitier: "",
		Acknowledgement: "",
		Aesthetic: "",
		Value: "经艺私人艺术管家",
		CompanyProfile: "公司简介",
		CompanyProfile1: "经艺联是一家以香港为总部 ，国内为基地，全球为市场的私人艺术管家推广集团。" ,
		CompanyProfile2: "我们有独特的铁三角推广引擎，以智能、道德、意志为原动力，发展推广当代艺术品，以新的市场策略、人才资本及强而有力的执行力，旨在改变现有的艺术生态圈，为艺术家提供一个更宽广、更透明、多维度的艺术销售平台，将中国的当代艺术弘扬世界。",
		CompanyProfile3: "",
		CompanyProfile4: "",
		CompanyProfile5: "",
		CompanyProfile6: "",
		Management: "管理团队",
		Name: "黄经国博士",
		position: "创始人 - 总裁",
		Resume: "「经艺联」始创人、「香港中西艺术及文化交流协会有限公司」主席、「大湾区香港艺术品交易中心有限公司」主席、「经艺管家学院」院长、「冠军专业管理有限公司」主席、《求知雅集》古董学会会长、香港中文大学《新亚书院》校董、《香港理工大学基金》永远荣誉副会长、《香港理工大学总裁协会》副理事长 及《世界杰出华人会》创会主席。兴趣方面也累积古董数十年收藏经验， 近70岁也考取《清华大学》美术学院-《清华大学》经济管理学院-《苏富比》艺术学院-艺术管理硕士资格。黄博士亦是《友邦保险》区域执行总监及荣誉顾问，拥有超过 4,500名 财务策划顾问「冠军家族团队」，当中包括 43位 资深区域总监及区域总监。工馀时在美国不断进修，获取众多科目不同资格，为人才资本培训专家、从事企业辅导、领袖培训、营销推广、保险及财务顾问管理工作数十年，也获得保险行业终身成就奖，为行业翘楚。",
		Name1: "梁嘉欣女士",
		position1: "市场推广总裁",
		Resume1: "梁小姐擁有超過10年的國際企業管理經驗，於自動化優化營運效率方面有豐富經驗。梁小姐負責經藝聯的市場推廣業務，以數字營銷和線上課程讓海外藝術愛好者了解中國當代藝術，以藝術打破地域界限、聯繫全球觀眾，發揮藝術於國際市場的獨有魅力！",
		Name2: "张翼雄律师",
		position2: "执行董事兼法律总监",
		Resume2: "艺术品收藏爱好者，现任香港执业律师（1995至今）、凯基证卷亚洲有限公司助理副总裁（2011至今）、香港上市公司汇能集团〔01539.HK〕独立非执行董事（2015至今）及香港友邦保险财富管理经理（2015年至今）， 曾担任香港中西区区议会区议员（2008至2015）。 张律师认为艺术品除了能陶冶观赏者的性情外，还见证了古今艺术家的努力成果，并通过交易及流通把当时当刻艺术文化收集、保存及传承。 他希望各艺术持份者及爱好者能通过「经艺联」此平台多认识艺术、交流艺术、保存艺术，促进艺术文化发展与传承！",
		Name3: "钟凯谚",
		position3: "艺术总监",
		Resume3: "曾就职于香港本土画廊，多年艺术市场经验，曾策划多场展览及主持分享活动，帮助拉近艺术与大众之间的距离，为艺术家职业生涯搭建基石。",
		Name4: "黄司政博士",
		position4: "执行董事兼行政总裁",
		Resume4: "黄司政先生，当代艺术品收藏爱好者，现任友邦保险（国际）有限公司区域总监、「经艺联」执行董事及行政总裁、经艺控股有限公司执行董事、香港中西艺术及文化交流协会有限公司执行董事。黄先生对中国当代艺术品情有独锺，当中对水墨画尤感兴趣，希望通过不同渠道接触更多艺术爱好者、艺术收藏家、年青新晋艺术家等等，籍此利用「经艺联」平台作互相交流、认识及发掘更多别具风格和存有历史价值的收藏品，促进香港艺术的长远发展！",
		Name5: "王京京女士",
		position5: "主理人及合伙人",
		Resume5: "王女士拥有超过10年的当代艺术品收藏、交易和推广经验。她负责经艺联的战略发展和日常运营，依托香港作为国际化的平台，推动中国当代艺术与国际市场的融合，为中国当代艺术家和艺术作品在国际舞台上展示中国魅力提供服务和帮助。“希望经艺联作为中国艺术家通往全球艺术市场的开放平台。”",
		Name6: "罗健昌",
		position6: "市場拓展总监",
		Resume6: "毕业于加拿大西安大略省大学电脑系，为资深网络科技专家。他曾带领名下一家公司在 Microsoft 勇夺一项全年大奖。他成功引入澳洲和美国上市公司及新加坡风险基金等策略性投资者，促成多次企业收购合并活动。他的投资包括美国上市企业、区块链生态圈和数码资产管理平台等。除科技外，他亦是著名商业心理教练，负责团队的销售培训。他被誉为企业老板、团队和富二代的心镜。",
		Name7: "钟凯谚",
		position7: "艺术执行总监",
		Resume7: "艺术创作属于个人情感和哲思的表达，艺术家在创作时投入的真诚情感更是无价的，然而我们还是需要一一地为他们标上数目字，才能量度它的价值。经艺联以此基础做推广，相信这个平台，定能为社会大众培养出更多出色的艺术家。",
		Marketplace: "我们的艺术市场",

    aboutUrl1: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_1.jpg',
    aboutUrl2: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_2.jpg',
    aboutUrl3: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_3.jpg',
    aboutUrl4: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_4.jpg',
    
	},
	// 漏掉的翻译
	LastTranslate: {
		Name1: "经艺联",
		Name2: "当代革新艺术交易平台",
		title1: '如何成为"私人艺术管家"',
		title2: '如何注册',
		title3: "加入我们",
		title4: "Join Us",
		Address: "如果您对我们的课程感兴趣，可联系我们，获取更多资讯。",
    Tel: "电邮: info@kingsarts.com",
		All: "全部",
		AllLabel1: "综合排序",
		AllLabel2: "时间排序",
		ScreenMenu: "筛选",
		ScreenTitle1: "杰出艺术品",
		ScreenTitle2: "价格",
		ScreenTitle3: "尺寸",
		ScreenTitle4: "主色调",
		ScreenTitle5: "形状",
		ScreenTitle6: "摆放空间",
		Attribute: "属性",
		AttributeName: "作品名称",
		AttributeAtr: "艺术家",
		AttributeDate: "创作时间",
		AttributeMaterial: "材质",
		AttributeSize: "尺寸",
		WorksDetails: "作品详情",
		RecommendedWorks: "推荐作品",
		ExpertsEvaluation: "专家评价",
		ArtInfo: "艺术家信息",
		ArtWorks: "艺术家作品",
		ArtIntroduced: "艺术家介绍",
		ArtCV: "艺术家履历",
		ArtCV1: "个展",
		ArtCV2: "群展",
		ArtCV3: "馆展",
		ArtCV4: "获奖",
		Challenge: "挑战自我",
		Activitier: "活动韵律",
		Acknowledgement: "修身养性",
		Aesthetic: "返璞归真",
		ICP: "保留所有权利",
		ICP1: "粤ICP备20032099号",

		SittingRoom: "客厅",
		Bedroom: "卧室",
		Outdoor: "室外",
		PublicHall: '公共大厅',
		NoMore: '没有更多推荐',
		registrationAgreement: '注册协议与隐私政策',
		Download: 'APP下载',

		PayOur: '关注我们',
		ContactPhone: '联系电话',
		CustomerService: '客户服务',
		ContactUs: '联络我们',
		LegalNotices: '法律声明',
		generalLaw: '一般条律',
		butlerManagement: '专属管家管理系统',
		SellerManagement: '卖家管理系统',
		Who: '我们是谁？',
		AboutUs: '关于我们',
		OurArtist: '我们的艺术家',
		OurTeam: '我们的团队',
		QA: '常见问题',
		Contact: '联络方式',
		FOOfTitle1: '你是艺术家/画廊/收藏家吗？',
		FOOfTitle2: '如何加入成为私人艺术管家？',
		ScanCodeTips1: '扫码下载经艺联卖家APP',
		ScanCodeTips2: '加入KingsArts',
		ScanCodeTips3: '扫码下载经艺联APP',
		ScanCodeTips4: '成为私人艺术管家',
		website: '官网',

		Below: '3000 以下',
		Above50000: '50000 以上',
		Above200: '200 以上'
	},
	ArtworkDetail: {
		Excellent: "杰出艺术品",
		Code: "编码",
		PriceTips: "包括运费",
		References: "规格参数",
		ProductNumber: "商品编号",
		ArtworkName: "作品名称",
		ArtworkType: "作品类型",
		Artists: "艺术家",
		CreateTime: "创作时间",
		Material: "材质",
		Size: "尺寸",

		Hue: "主色调",
		Red: "红色",
		Green: '绿色',
		Blue: '蓝色',
		Yellow: "黄色",
		Gray: '灰色',
		Other: "其它",
		Square: '正方形',
		Rectangle1: '长方形（横）',
		Rectangle2: '长方形（竖）',
		Roundness: '圆形',
		OtherShapes: '其它形状',
		Shape: '形状',

		ThemeColor: "主色調",
		Shape: "形狀",
		Seller: "卖家",
		TransactionHistory: "交易记录",
		Time1: "第",
		Time2: "次",
		ArtworkDetails: "作品详情",
		Comments: "留言",
		ArtworkInformation: "艺术品信息",
		ArtCritics: "艺术评价",
		Details: "图文详情",
		ArtistProfile1: "艺术家简介",
		ArtistProfile2: "艺术家介绍",
		SoloExhibitions: "个展",
		GroupExhibitions: "群展",
		PavilionExhibitions: "馆展",
		Awards: "获奖",
		SeeAll: "查看全部",
		TakeBack: "收回",
		MoreData: "没有更多数据",
		Recommendations: "推荐商品",
		ArtistWorks: "艺术家作品",
		sold: "已售出",

		withdrawn: "已下架",
		Next: "下一页",
		Previous: "上一页",
		Home: "首頁",
		ArtworkName: "作品名称",
		Material: "材质",
		CreateTime: "创作时间",
		download: "下载APP购买",
		viewArt: "查看艺术家主页＞",
		how: "共",
		artworks: "件艺术品",
		works: "作品",
		Pieces: "件",
		EnterName: "输入作品名称",
		EnterArtName: "输入艺术家名称",
		Unlimited: "不限",
		select: "请选择",
		ALL: "全部",
		DefaultSort: "综合排序",
		TimeSort: "时间排序",
		Sort: "筛选",
		Reset: "重置",
		Confirm: "确定",
		ArtistInfo: "艺术家信息",
		ArtistResume: "艺术家履历",
		NoMore: "— 我是有底线的 —",
		Loading: "加载中",
		Refresh: "刷新成功",
		PullingText: "下拉即可刷新",
		LoosingText: "释放即可刷新",
		Message: "董事长寄语",
		What: "什么是“二次交易”",
		How: "如何成为“私人艺术管家”"
	},
	// 邀请注册
	Register: {
		Title: "邀请您加入经艺联",
		NameBar1: "艺术管家",
		Reg: "立即注册",
		MobilePla: "请输入手机号码",
		nickNamePla: "请输入您的名称",
		emailPla: "请输入您的邮箱",
		VCodePla: "请输入验证码",
		VCodeBtn: "获取验证码",
		PwdPla: "请输入密码",
		SubmitBtn: "同意协议并注册",
		RidaoBtn: "我同意",
		Agreement: "《经艺平台服务协议》",
		Radio: "请勾选经艺平台服务协议",
		Success: "验证码发送成功",
		PwdPlaErr: "两次输入的密码不相同",
		Countries: "选择区号",
		smsCode: "请选择选择区号",
		videoTitle: "经艺联介绍",
		videoTitle2: "当代艺术市场的机遇",
		videoTitle3: "什么是艺术",
		hot: "热门地区",
		all: "所有地区",
		videoText: "经艺联是一个艺术品线上交易平台",
		downLoad: '下载APP安装'
	}
}